import * as React from 'react';
import { EmptyState, type CameraFeedState } from '@relay-towing/ui';
import { CameraOff } from 'lucide-react';

/** What each camera that cannot open says, and what to do about it. */
const WORDS: Partial<
  Record<CameraFeedState | 'unreadable', { title: string; description: string }>
> = {
  denied: {
    title: 'Camera is blocked',
    description:
      "Allow the camera for this site in your browser's settings, then try again.",
  },
  missing: {
    title: 'No camera',
    description: 'This device has no camera Relay can use.',
  },
  insecure: {
    title: 'The camera needs a secure page',
    description: 'Open Relay from its https:// address to use the camera.',
  },
  failed: {
    title: 'The camera did not open',
    description: 'Another app may be using it. Close that app and try again.',
  },
  unreadable: {
    title: 'Codes cannot be read here',
    description:
      'The reader did not load. Check your connection and try again.',
  },
};

/**
 * Why a scanner's camera is not showing anything, for a ScanFrame's notice;
 * nothing while it is opening or live. `unreadable` is a camera that works
 * with nothing to read its frames.
 */
export function cameraNotice(
  state: CameraFeedState | 'unreadable',
  action?: React.ReactNode
): React.ReactNode {
  const words = WORDS[state];
  if (!words) return undefined;
  return (
    <EmptyState
      icon={CameraOff}
      size="sm"
      title={words.title}
      description={words.description}
      action={action}
    />
  );
}
